// src/App.js
import React, { useContext } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { Box, CircularProgress, Typography } from '@mui/material';
import theme from './theme';
import TopBar from './components/TopBar';
import Sidebar from './components/Sidebar';
import Dashboard from './components/Dashboard';
import CreateRestaurant from './components/CreateRestaurant';
import Restaurants from './components/Restaurants';
import EditRestaurant from './components/EditRestaurant';
import Invoice from './components/Invoice';
import CancelCommandeCB from './components/CancelCommandeCB';
import Livreurs from './components/Livreurs'; // Import the new component
import Login from './components/Login';
import { AuthProvider, AuthContext } from './context/AuthContext';
import { SidebarProvider } from './context/SidebarContext';

// Dispatch Component to render iframe
const Dispatch = () => {
  return (
    <Box sx={{ height: '100vh', overflow: 'hidden' }}>
      <iframe
        src="https://dispatchv2.lalivraison.ma/"
        title="Dispatch"
        style={{ width: '100%', height: '100%', border: 'none' }}
      />
    </Box>
  );
};

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { user, loading } = useContext(AuthContext);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
        <Typography sx={{ ml: 2 }}>Loading...</Typography>
      </Box>
    );
  }

  return user ? children : <Navigate to="/login" />;
};

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <AuthProvider>
          <SidebarProvider>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route
                path="*"
                element={
                  <ProtectedRoute>
                    <TopBar />
                    <Box sx={{ display: 'flex' }}>
                      <Sidebar />
                      <Box
                        component="main"
                        sx={{
                          flexGrow: 1,
                          pt: 8,
                          pl: 0,
                          transition: 'margin-left 0.3s ease',
                        }}
                      >
                        <Routes>
                          <Route path="/dashboard" element={<Dashboard />} />
                          <Route path="/create-restaurant" element={<CreateRestaurant />} />
                          <Route path="/restaurants" element={<Restaurants />} />
                          <Route path="/edit-restaurant/:id" element={<EditRestaurant />} />
                          <Route path="/dispatch" element={<Dispatch />} />
                          <Route path="/invoices" element={<Invoice />} />
                          <Route path="/cancel-commande-cb" element={<CancelCommandeCB />} />
                          <Route path="/livreurs" element={<Livreurs />} /> {/* Add new route */}
                          <Route path="/" element={<Dashboard />} />
                        </Routes>
                      </Box>
                    </Box>
                  </ProtectedRoute>
                }
              />
            </Routes>
          </SidebarProvider>
        </AuthProvider>
      </Router>
    </ThemeProvider>
  );
};

export default App;